export enum PathwaysAuthoringState {
  new,
  inReview,
  readonly
}
